// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"232":"e5199b1e","237":"f928494d","453":"239d2484","768":"177e907a","932":"c75d923c"}[chunkId] + ".chunk.js";
};